import { ReactNode, useState } from "react";
import { Accordion, AccordionDetails, AccordionProps, AccordionSummary, Divider } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

export type CoreAccordionProps = Omit<AccordionProps, "children"> & {
	summary: ReactNode;
	children: ReactNode;
	expanded?: boolean;
	handleExpandedChange?: (event: React.SyntheticEvent, isExpanded: boolean) => void;
	expandIcon?: ReactNode;
};

export default function CoreAccordion({
	summary,
	children,
	expanded,
	handleExpandedChange,
	expandIcon,
	...props
}: CoreAccordionProps) {
	const [internalExpanded, setInternalExpanded] = useState(expanded ?? false);
	const isControlled = expanded !== undefined;
	const onChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
		if (!isControlled) setInternalExpanded(isExpanded);
		if (handleExpandedChange) handleExpandedChange(event, isExpanded);
	};

	return (
		<Accordion expanded={isControlled ? expanded : internalExpanded} onChange={onChange} {...props}>
			<AccordionSummary expandIcon={expandIcon ?? <ExpandMore />}>{summary}</AccordionSummary>
			<AccordionDetails>
				<Divider />
				{children}
			</AccordionDetails>
		</Accordion>
	);
}
